export default __webpack_public_path__ + "static/media/img3.f690ffa2.jpg";